module.exports = __webpack_public_path__ + "img/28u_icon.085a97cf.png";